module.exports = __webpack_public_path__ + "img/heart.0c60b5f7.svg";